/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as Char126RouteImport } from './routes/~'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicResourcesRouteImport } from './routes/_public/resources'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminDevelopersRouteImport } from './routes/admin/developers'
import { Route as AdminProfileRouteImport } from './routes/admin/profile'
import { Route as AdminVendorsRouteImport } from './routes/admin/vendors'
import { Route as AuthCreateAccountRouteImport } from './routes/auth/create-account'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as Char126IndexRouteImport } from './routes/~/index'
import { Route as Char126DevelopersRouteImport } from './routes/~/developers'
import { Route as Char126ProfileRouteImport } from './routes/~/profile'
import { Route as Char126ServiceAccountsRouteImport } from './routes/~/service-accounts'
import { Route as PublicComponentsIndexRouteImport } from './routes/_public/components/index'
import { Route as PublicComponentsAppIdRouteImport } from './routes/_public/components/$appId'
import { Route as Char126ComponentsNewRouteImport } from './routes/~/components/new'
import { Route as AdminComponentsAppIdIndexRouteImport } from './routes/admin/components/$appId/index'
import { Route as AdminComponentsAppIdChangesRouteImport } from './routes/admin/components/$appId/changes'
import { Route as AdminComponentsAppIdEditRouteImport } from './routes/admin/components/$appId/edit'
import { Route as AdminComponentsAppIdVersionsRouteImport } from './routes/admin/components/$appId/versions'
import { Route as Char126ComponentsAppIdIndexRouteImport } from './routes/~/components/$appId/index'
import { Route as Char126ComponentsAppIdEditRouteImport } from './routes/~/components/$appId/edit'
import { Route as Char126ComponentsAppIdVersionsRouteImport } from './routes/~/components/$appId/versions'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const Char126Route = Char126RouteImport.update({
  id: '/~',
  path: '/~',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResourcesRoute = PublicResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => PublicRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDevelopersRoute = AdminDevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVendorsRoute = AdminVendorsRouteImport.update({
  id: '/vendors',
  path: '/vendors',
  getParentRoute: () => AdminRoute,
} as any)
const AuthCreateAccountRoute = AuthCreateAccountRouteImport.update({
  id: '/create-account',
  path: '/create-account',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const Char126IndexRoute = Char126IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Char126Route,
} as any)
const Char126DevelopersRoute = Char126DevelopersRouteImport.update({
  id: '/developers',
  path: '/developers',
  getParentRoute: () => Char126Route,
} as any)
const Char126ProfileRoute = Char126ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => Char126Route,
} as any)
const Char126ServiceAccountsRoute = Char126ServiceAccountsRouteImport.update({
  id: '/service-accounts',
  path: '/service-accounts',
  getParentRoute: () => Char126Route,
} as any)
const PublicComponentsIndexRoute = PublicComponentsIndexRouteImport.update({
  id: '/components/',
  path: '/components/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicComponentsAppIdRoute = PublicComponentsAppIdRouteImport.update({
  id: '/components/$appId',
  path: '/components/$appId',
  getParentRoute: () => PublicRoute,
} as any)
const Char126ComponentsNewRoute = Char126ComponentsNewRouteImport.update({
  id: '/components/new',
  path: '/components/new',
  getParentRoute: () => Char126Route,
} as any)
const AdminComponentsAppIdIndexRoute =
  AdminComponentsAppIdIndexRouteImport.update({
    id: '/components/$appId/',
    path: '/components/$appId/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminComponentsAppIdChangesRoute =
  AdminComponentsAppIdChangesRouteImport.update({
    id: '/components/$appId/changes',
    path: '/components/$appId/changes',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminComponentsAppIdEditRoute =
  AdminComponentsAppIdEditRouteImport.update({
    id: '/components/$appId/edit',
    path: '/components/$appId/edit',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminComponentsAppIdVersionsRoute =
  AdminComponentsAppIdVersionsRouteImport.update({
    id: '/components/$appId/versions',
    path: '/components/$appId/versions',
    getParentRoute: () => AdminRoute,
  } as any)
const Char126ComponentsAppIdIndexRoute =
  Char126ComponentsAppIdIndexRouteImport.update({
    id: '/components/$appId/',
    path: '/components/$appId/',
    getParentRoute: () => Char126Route,
  } as any)
const Char126ComponentsAppIdEditRoute =
  Char126ComponentsAppIdEditRouteImport.update({
    id: '/components/$appId/edit',
    path: '/components/$appId/edit',
    getParentRoute: () => Char126Route,
  } as any)
const Char126ComponentsAppIdVersionsRoute =
  Char126ComponentsAppIdVersionsRouteImport.update({
    id: '/components/$appId/versions',
    path: '/components/$appId/versions',
    getParentRoute: () => Char126Route,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/~': typeof Char126RouteWithChildren
  '/resources': typeof PublicResourcesRoute
  '/admin/developers': typeof AdminDevelopersRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/vendors': typeof AdminVendorsRoute
  '/auth/create-account': typeof AuthCreateAccountRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/~/developers': typeof Char126DevelopersRoute
  '/~/profile': typeof Char126ProfileRoute
  '/~/service-accounts': typeof Char126ServiceAccountsRoute
  '/admin/': typeof AdminIndexRoute
  '/~/': typeof Char126IndexRoute
  '/components/$appId': typeof PublicComponentsAppIdRoute
  '/~/components/new': typeof Char126ComponentsNewRoute
  '/components/': typeof PublicComponentsIndexRoute
  '/admin/components/$appId/changes': typeof AdminComponentsAppIdChangesRoute
  '/admin/components/$appId/edit': typeof AdminComponentsAppIdEditRoute
  '/admin/components/$appId/versions': typeof AdminComponentsAppIdVersionsRoute
  '/~/components/$appId/edit': typeof Char126ComponentsAppIdEditRoute
  '/~/components/$appId/versions': typeof Char126ComponentsAppIdVersionsRoute
  '/admin/components/$appId/': typeof AdminComponentsAppIdIndexRoute
  '/~/components/$appId/': typeof Char126ComponentsAppIdIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/resources': typeof PublicResourcesRoute
  '/admin/developers': typeof AdminDevelopersRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/vendors': typeof AdminVendorsRoute
  '/auth/create-account': typeof AuthCreateAccountRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/~/developers': typeof Char126DevelopersRoute
  '/~/profile': typeof Char126ProfileRoute
  '/~/service-accounts': typeof Char126ServiceAccountsRoute
  '/': typeof PublicIndexRoute
  '/admin': typeof AdminIndexRoute
  '/~': typeof Char126IndexRoute
  '/components/$appId': typeof PublicComponentsAppIdRoute
  '/~/components/new': typeof Char126ComponentsNewRoute
  '/components': typeof PublicComponentsIndexRoute
  '/admin/components/$appId/changes': typeof AdminComponentsAppIdChangesRoute
  '/admin/components/$appId/edit': typeof AdminComponentsAppIdEditRoute
  '/admin/components/$appId/versions': typeof AdminComponentsAppIdVersionsRoute
  '/~/components/$appId/edit': typeof Char126ComponentsAppIdEditRoute
  '/~/components/$appId/versions': typeof Char126ComponentsAppIdVersionsRoute
  '/admin/components/$appId': typeof AdminComponentsAppIdIndexRoute
  '/~/components/$appId': typeof Char126ComponentsAppIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/~': typeof Char126RouteWithChildren
  '/_public/resources': typeof PublicResourcesRoute
  '/admin/developers': typeof AdminDevelopersRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/vendors': typeof AdminVendorsRoute
  '/auth/create-account': typeof AuthCreateAccountRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/~/developers': typeof Char126DevelopersRoute
  '/~/profile': typeof Char126ProfileRoute
  '/~/service-accounts': typeof Char126ServiceAccountsRoute
  '/_public/': typeof PublicIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/~/': typeof Char126IndexRoute
  '/_public/components/$appId': typeof PublicComponentsAppIdRoute
  '/~/components/new': typeof Char126ComponentsNewRoute
  '/_public/components/': typeof PublicComponentsIndexRoute
  '/admin/components/$appId/changes': typeof AdminComponentsAppIdChangesRoute
  '/admin/components/$appId/edit': typeof AdminComponentsAppIdEditRoute
  '/admin/components/$appId/versions': typeof AdminComponentsAppIdVersionsRoute
  '/~/components/$appId/edit': typeof Char126ComponentsAppIdEditRoute
  '/~/components/$appId/versions': typeof Char126ComponentsAppIdVersionsRoute
  '/admin/components/$appId/': typeof AdminComponentsAppIdIndexRoute
  '/~/components/$appId/': typeof Char126ComponentsAppIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth'
    | '/~'
    | '/resources'
    | '/admin/developers'
    | '/admin/profile'
    | '/admin/vendors'
    | '/auth/create-account'
    | '/auth/login'
    | '/auth/reset-password'
    | '/~/developers'
    | '/~/profile'
    | '/~/service-accounts'
    | '/admin/'
    | '/~/'
    | '/components/$appId'
    | '/~/components/new'
    | '/components/'
    | '/admin/components/$appId/changes'
    | '/admin/components/$appId/edit'
    | '/admin/components/$appId/versions'
    | '/~/components/$appId/edit'
    | '/~/components/$appId/versions'
    | '/admin/components/$appId/'
    | '/~/components/$appId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/resources'
    | '/admin/developers'
    | '/admin/profile'
    | '/admin/vendors'
    | '/auth/create-account'
    | '/auth/login'
    | '/auth/reset-password'
    | '/~/developers'
    | '/~/profile'
    | '/~/service-accounts'
    | '/'
    | '/admin'
    | '/~'
    | '/components/$appId'
    | '/~/components/new'
    | '/components'
    | '/admin/components/$appId/changes'
    | '/admin/components/$appId/edit'
    | '/admin/components/$appId/versions'
    | '/~/components/$appId/edit'
    | '/~/components/$appId/versions'
    | '/admin/components/$appId'
    | '/~/components/$appId'
  id:
    | '__root__'
    | '/_public'
    | '/admin'
    | '/auth'
    | '/~'
    | '/_public/resources'
    | '/admin/developers'
    | '/admin/profile'
    | '/admin/vendors'
    | '/auth/create-account'
    | '/auth/login'
    | '/auth/reset-password'
    | '/~/developers'
    | '/~/profile'
    | '/~/service-accounts'
    | '/_public/'
    | '/admin/'
    | '/~/'
    | '/_public/components/$appId'
    | '/~/components/new'
    | '/_public/components/'
    | '/admin/components/$appId/changes'
    | '/admin/components/$appId/edit'
    | '/admin/components/$appId/versions'
    | '/~/components/$appId/edit'
    | '/~/components/$appId/versions'
    | '/admin/components/$appId/'
    | '/~/components/$appId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  Char126Route: typeof Char126RouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/~': {
      id: '/~'
      path: '/~'
      fullPath: '/~'
      preLoaderRoute: typeof Char126RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/resources': {
      id: '/_public/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof PublicResourcesRouteImport
      parentRoute: typeof PublicRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/developers': {
      id: '/admin/developers'
      path: '/developers'
      fullPath: '/admin/developers'
      preLoaderRoute: typeof AdminDevelopersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/vendors': {
      id: '/admin/vendors'
      path: '/vendors'
      fullPath: '/admin/vendors'
      preLoaderRoute: typeof AdminVendorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/auth/create-account': {
      id: '/auth/create-account'
      path: '/create-account'
      fullPath: '/auth/create-account'
      preLoaderRoute: typeof AuthCreateAccountRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/~/': {
      id: '/~/'
      path: '/'
      fullPath: '/~/'
      preLoaderRoute: typeof Char126IndexRouteImport
      parentRoute: typeof Char126Route
    }
    '/~/developers': {
      id: '/~/developers'
      path: '/developers'
      fullPath: '/~/developers'
      preLoaderRoute: typeof Char126DevelopersRouteImport
      parentRoute: typeof Char126Route
    }
    '/~/profile': {
      id: '/~/profile'
      path: '/profile'
      fullPath: '/~/profile'
      preLoaderRoute: typeof Char126ProfileRouteImport
      parentRoute: typeof Char126Route
    }
    '/~/service-accounts': {
      id: '/~/service-accounts'
      path: '/service-accounts'
      fullPath: '/~/service-accounts'
      preLoaderRoute: typeof Char126ServiceAccountsRouteImport
      parentRoute: typeof Char126Route
    }
    '/_public/components/': {
      id: '/_public/components/'
      path: '/components'
      fullPath: '/components/'
      preLoaderRoute: typeof PublicComponentsIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/components/$appId': {
      id: '/_public/components/$appId'
      path: '/components/$appId'
      fullPath: '/components/$appId'
      preLoaderRoute: typeof PublicComponentsAppIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/~/components/new': {
      id: '/~/components/new'
      path: '/components/new'
      fullPath: '/~/components/new'
      preLoaderRoute: typeof Char126ComponentsNewRouteImport
      parentRoute: typeof Char126Route
    }
    '/admin/components/$appId/': {
      id: '/admin/components/$appId/'
      path: '/components/$appId'
      fullPath: '/admin/components/$appId/'
      preLoaderRoute: typeof AdminComponentsAppIdIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/components/$appId/changes': {
      id: '/admin/components/$appId/changes'
      path: '/components/$appId/changes'
      fullPath: '/admin/components/$appId/changes'
      preLoaderRoute: typeof AdminComponentsAppIdChangesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/components/$appId/edit': {
      id: '/admin/components/$appId/edit'
      path: '/components/$appId/edit'
      fullPath: '/admin/components/$appId/edit'
      preLoaderRoute: typeof AdminComponentsAppIdEditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/components/$appId/versions': {
      id: '/admin/components/$appId/versions'
      path: '/components/$appId/versions'
      fullPath: '/admin/components/$appId/versions'
      preLoaderRoute: typeof AdminComponentsAppIdVersionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/~/components/$appId/': {
      id: '/~/components/$appId/'
      path: '/components/$appId'
      fullPath: '/~/components/$appId/'
      preLoaderRoute: typeof Char126ComponentsAppIdIndexRouteImport
      parentRoute: typeof Char126Route
    }
    '/~/components/$appId/edit': {
      id: '/~/components/$appId/edit'
      path: '/components/$appId/edit'
      fullPath: '/~/components/$appId/edit'
      preLoaderRoute: typeof Char126ComponentsAppIdEditRouteImport
      parentRoute: typeof Char126Route
    }
    '/~/components/$appId/versions': {
      id: '/~/components/$appId/versions'
      path: '/components/$appId/versions'
      fullPath: '/~/components/$appId/versions'
      preLoaderRoute: typeof Char126ComponentsAppIdVersionsRouteImport
      parentRoute: typeof Char126Route
    }
  }
}

interface PublicRouteChildren {
  PublicResourcesRoute: typeof PublicResourcesRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicComponentsAppIdRoute: typeof PublicComponentsAppIdRoute
  PublicComponentsIndexRoute: typeof PublicComponentsIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicResourcesRoute: PublicResourcesRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicComponentsAppIdRoute: PublicComponentsAppIdRoute,
  PublicComponentsIndexRoute: PublicComponentsIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface AdminRouteChildren {
  AdminDevelopersRoute: typeof AdminDevelopersRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminVendorsRoute: typeof AdminVendorsRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminComponentsAppIdChangesRoute: typeof AdminComponentsAppIdChangesRoute
  AdminComponentsAppIdEditRoute: typeof AdminComponentsAppIdEditRoute
  AdminComponentsAppIdVersionsRoute: typeof AdminComponentsAppIdVersionsRoute
  AdminComponentsAppIdIndexRoute: typeof AdminComponentsAppIdIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminDevelopersRoute: AdminDevelopersRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminVendorsRoute: AdminVendorsRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminComponentsAppIdChangesRoute: AdminComponentsAppIdChangesRoute,
  AdminComponentsAppIdEditRoute: AdminComponentsAppIdEditRoute,
  AdminComponentsAppIdVersionsRoute: AdminComponentsAppIdVersionsRoute,
  AdminComponentsAppIdIndexRoute: AdminComponentsAppIdIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AuthRouteChildren {
  AuthCreateAccountRoute: typeof AuthCreateAccountRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCreateAccountRoute: AuthCreateAccountRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface Char126RouteChildren {
  Char126DevelopersRoute: typeof Char126DevelopersRoute
  Char126ProfileRoute: typeof Char126ProfileRoute
  Char126ServiceAccountsRoute: typeof Char126ServiceAccountsRoute
  Char126IndexRoute: typeof Char126IndexRoute
  Char126ComponentsNewRoute: typeof Char126ComponentsNewRoute
  Char126ComponentsAppIdEditRoute: typeof Char126ComponentsAppIdEditRoute
  Char126ComponentsAppIdVersionsRoute: typeof Char126ComponentsAppIdVersionsRoute
  Char126ComponentsAppIdIndexRoute: typeof Char126ComponentsAppIdIndexRoute
}

const Char126RouteChildren: Char126RouteChildren = {
  Char126DevelopersRoute: Char126DevelopersRoute,
  Char126ProfileRoute: Char126ProfileRoute,
  Char126ServiceAccountsRoute: Char126ServiceAccountsRoute,
  Char126IndexRoute: Char126IndexRoute,
  Char126ComponentsNewRoute: Char126ComponentsNewRoute,
  Char126ComponentsAppIdEditRoute: Char126ComponentsAppIdEditRoute,
  Char126ComponentsAppIdVersionsRoute: Char126ComponentsAppIdVersionsRoute,
  Char126ComponentsAppIdIndexRoute: Char126ComponentsAppIdIndexRoute,
}

const Char126RouteWithChildren =
  Char126Route._addFileChildren(Char126RouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  Char126Route: Char126RouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
